const all = ['trustedSources']
const lists = [...all, 'list']

export const trustedSourceKeys = {
  all,
  lists,
}
